import React from 'react';
import {useLocation} from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import SubHeader from '../components/SubHeader';

const MasterLayout = (props) => {
    const {pathname}= useLocation();
    
    return(
        <div className={`main-page pt-80 ${props.className}`}>
            <Header className={props.headerClassName}/>
            {pathname!=="/" && <SubHeader/>}
            {
                props.children
            }
             {pathname!=="/" && <Footer/>}
        </div>
    );
}   

export default MasterLayout;